import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EditSubcategoriesForm } from '../../../../components/admin-dashboard-component/subcategories/edit-subcategories-form/edit-subcategories-form';

@Component({
  selector: 'app-admin-edit-subcategory',
  imports: [EditSubcategoriesForm],
  templateUrl: './admin-edit-subcategory.html',
  styleUrl: './admin-edit-subcategory.scss',
})
export class AdminEditSubcategory {
  private route = inject(ActivatedRoute);
  subcategoryId = this.route.snapshot.paramMap.get('id');
}
